import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsfTerminalsApiMeta } from "../apiMeta";
import {
  type TerminalTransportsInput,
  terminalTransportsInputSchema,
} from "./shared/terminalTransports.input";
import {
  type TerminalTransport,
  terminalTransportSchema,
} from "./shared/terminalTransports.output";

/**
 * Metadata for the fetchTerminalTransports endpoint
 */
export const terminalTransportsMeta = {
  functionName: "fetchTerminalTransports",
  endpoint: "/terminalTransports",
  inputSchema: terminalTransportsInputSchema,
  outputSchema: terminalTransportSchema.array(),
  sampleParams: {},
  endpointDescription: "List transportation information for all terminals.",
} satisfies EndpointMeta<TerminalTransportsInput, TerminalTransport[]>;

/**
 * Fetch function for retrieving transportation information for all terminals
 */
const { fetch, useHook } = createFetchAndHook<
  TerminalTransportsInput,
  TerminalTransport[]
>({
  api: wsfTerminalsApiMeta,
  endpoint: terminalTransportsMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/terminalTransports.endpoints").terminalTransportsGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving transportation information for all terminals
 */
export const fetchTerminalTransports: FetchFactory<
  TerminalTransportsInput,
  TerminalTransport[]
> = fetch;

/**
 * React Query hook for retrieving transportation information for all terminals
 */
export const useTerminalTransports: HookFactory<
  TerminalTransportsInput,
  TerminalTransport[]
> = useHook;
